import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";
import { useContent } from "../lib/ContentContext";

export default function MarqueeEditorial() {
  const c = useContent();
  const items = [1, 2, 3, 4, 5, 6].map((n) => c(`marquee.${n}`));
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-linen bg-shell py-6"
      aria-hidden="true"
    >
      <Marquee speed={20} gradient={false}>
        {items.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-16">
            <span className="whitespace-nowrap font-serif text-2xl font-light italic tracking-tight text-smoke md:text-3xl">
              {item}
            </span>
            <Asterisk className="h-5 w-5 text-moss" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
